import { useCallback, useMemo, useState } from "react";

const SECTION_KEYS = {
  financialSummary: "financialSummary",
  medicalBreakdown: "medicalBreakdown",
  settlementStatement: "settlementStatement",
};

const SECTION_LABELS = {
  [SECTION_KEYS.settlementStatement]: "Client Details",
  [SECTION_KEYS.medicalBreakdown]: "Medical Breakdown",
  [SECTION_KEYS.financialSummary]: "Total Medical Reduction and Fee Schedule Calculator",
};

function buildSelectedSections(availableSections) {
  return Object.keys(SECTION_LABELS).reduce((accumulator, key) => {
    accumulator[key] = Boolean(availableSections?.[key]);
    return accumulator;
  }, {});
}

export default function useSettlementExportModal(availableSections) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedSections, setSelectedSections] = useState(() =>
    buildSelectedSections(availableSections)
  );

  const sectionOptions = useMemo(
    () =>
      Object.keys(SECTION_LABELS).map((key) => ({
        key,
        label: SECTION_LABELS[key],
        disabled: !availableSections?.[key],
      })),
    [availableSections]
  );

  const hasSelectedSections = useMemo(
    () => Object.values(selectedSections).some(Boolean),
    [selectedSections]
  );

  const handleOpenModal = useCallback(() => {
    setSelectedSections(buildSelectedSections(availableSections));
    setIsOpen(true);
  }, [availableSections]);

  const handleCloseModal = useCallback(() => {
    setIsOpen(false);
  }, []);

  const handleToggleSection = useCallback((sectionKey) => {
    setSelectedSections((previousState) => ({
      ...previousState,
      [sectionKey]: !previousState[sectionKey],
    }));
  }, []);

  return {
    isOpen,
    selectedSections,
    sectionOptions,
    hasSelectedSections,
    handleOpenModal,
    handleCloseModal,
    handleToggleSection,
  };
}
